import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { IconeContainer, InfoContainer, TextContainer } from "./style";
import { FaExclamation } from "react-icons/fa";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: () => void;
}

export function ModalConfirmarEditarFornecedor({
  show,
  handleClose,
  onSubmit,
}: Props) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Editar fornecedor"
      centered
    >
      <InfoContainer>
        <IconeContainer>
          <FaExclamation />
        </IconeContainer>
        <TextContainer>
          Deseja salvar as alterações realizadas no cadastro do fornecedor?{" "}
          <strong>
            Após a confirmação, esta ação não poderá ser revertida.
          </strong>
        </TextContainer>
      </InfoContainer>
      <div className="d-flex justify-content-end gap-4 mt-4">
        <PrimaryButton
          style={{ width: "150px" }}
          outline
          variante="primary"
          onClick={handleClose}
        >
          Cancelar
        </PrimaryButton>
        <PrimaryButton style={{ width: "150px" }} onClick={onSubmit}>
          Salvar
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
